/**
 * TanStack Query hooks for `scheduled-email-report-daily-weekly-monthly`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	scheduledEmailReportDailyWeeklyMonthlyQueryKeys,
	type CreateScheduledEmailReportDailyWeeklyMonthlyBody,
	type ListScheduledEmailReportDailyWeeklyMonthlyResponse,
	type ScheduledEmailReportDailyWeeklyMonthlyRow,
} from "./api";

export function useScheduledEmailReportDailyWeeklyMonthlyList(): UseQueryResult<ListScheduledEmailReportDailyWeeklyMonthlyResponse, Error> {
	return useQuery({
		queryKey: scheduledEmailReportDailyWeeklyMonthlyQueryKeys.list(),
		queryFn: list,
	});
}

export function useScheduledEmailReportDailyWeeklyMonthlyCreate(): UseMutationResult<ScheduledEmailReportDailyWeeklyMonthlyRow, Error, CreateScheduledEmailReportDailyWeeklyMonthlyBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: scheduledEmailReportDailyWeeklyMonthlyQueryKeys.all });
		},
	});
}

export function useScheduledEmailReportDailyWeeklyMonthlyDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: scheduledEmailReportDailyWeeklyMonthlyQueryKeys.all });
		},
	});
}
